import React, { useState } from 'react';
import api from '../services/api';
//import userAuth from "../hooks/UserAuth";
import { useAuth } from '../context/AuthContext';

export function DepositPage() {
  const [amount, setAmount] = useState<number>(50);
  const [customAmount, setCustomAmount] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth(); // Pega o objeto user do usuário logado
  // const { user } = userAuth(); // Pega o objeto user do usuário logado

  const suggestedAmounts = [20, 50, 100, 200, 500];

  const handleAmountClick = (value: number) => {
    setAmount(value);
    setCustomAmount('');
  };

  const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCustomAmount(value);
    if (parseFloat(value) > 0) {
      setAmount(parseFloat(value));
    }
  };

  const handleDeposit = async () => {
    if (!user) { // Verifica se o objeto user existe
      setError('Você precisa estar logado para fazer um depósito.');
      return;
    }
    if (amount <= 0) {
      setError('O valor do depósito deve ser maior que zero.');
      return;
    }
    setError(null);
    setLoading(true);

    try {
      const response = await api.post('/create-checkout-session.php', {
        amount: amount,
        user_id: user.id, // Usa o id do objeto user
      });

      if (response.data.url) {
        // Redireciona o usuário para a página de pagamento do Stripe
        window.location.href = response.data.url;
      } else {
        setError('Não foi possível iniciar o pagamento. Tente novamente.');
      }
    } catch (err) {
      setError('Ocorreu um erro no servidor. Por favor, tente mais tarde.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center text-gray-800">Faça um Depósito</h1>
        
        <div className="grid grid-cols-3 gap-4">
          {suggestedAmounts.map((value) => (
            <button
              key={value}
              onClick={() => handleAmountClick(value)}
              className={`p-4 rounded-lg font-semibold text-center transition-colors ${
                amount === value && !customAmount
                  ? 'bg-primary text-white'
                  : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
              }`}>
              R$ {value}
            </button>
          ))}
        </div>

        <div>
          <label htmlFor="custom-amount" className="text-sm font-medium text-gray-700">Ou digite um valor</label>
          <input
            id="custom-amount"
            type="number"
            value={customAmount}
            onChange={handleCustomAmountChange}
            placeholder="Ex: 75"
            className="w-full px-4 py-2 mt-2 text-lg border border-gray-300 rounded-lg focus:ring-primary focus:border-primary"
          />
        </div>

        {error && <p className="text-sm text-red-600 text-center">{error}</p>}

        <button
          onClick={handleDeposit}
          disabled={loading}
          className="w-full px-4 py-3 font-bold text-white bg-primary rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:bg-purple-300">
          {loading ? 'Carregando...' : `Depositar R$ ${amount}`}
        </button>
      </div>
    </div>
  );
}
